<template>
    <CommonDialog v-show="show" :title="title" class="prompt-dialog" @close="handleClose">
        <template v-slot:msg>
            <div class="prompt">
                <span class="dialog-message">{{ message }}</span>
                <input class="dialog-input" type="text" v-model="promptMessage" :placeholder="placeholder">
            </div>
        </template>
        <template v-slot:buttons>
            <div class="button-slot button-group">
                <div class="btn-txt dialog-btn" :class="buttonBackgroundColor(cancelBtnColor)" @click="handleCancel">
                    <span>{{ cancelTxt }}</span>
                    <span class="prompt-txt">{{ cancelPrompt }}</span>
                </div>
                <div class="btn-txt dialog-btn" :class="buttonBackgroundColor(confirmBtnColor)" @click="handleConfirm">
                    <span>{{ confirmTxt }}</span>
                    <span class="prompt-txt">{{ confirmPrompt }}</span>
                </div>
            </div>
        </template>
    </CommonDialog>
</template>

<script>
import CommonDialog from './Dialog.vue';
import { buttonBackgroundColor } from '../../js/dialog/dialog_button';

export default {
    name: "PromptDialog",
    data: function () {
        return {
            show: false,
            title: "標題",
            message: "名稱",
            confirmTxt: "確定",
            cancelTxt: "取消",
            confirmCallback: null,
            cancelCallback: null,
            promptMessage: "",
            placeholder: "",
            confirmBtnColor: "orange",
            cancelBtnColor: "blue",
            buttonBackgroundColor,
            cancelPrompt: "",
            confirmPrompt: ""
        }
    },
    components: {
        CommonDialog
    },
    methods: {
        /**
         * 
         *
         * @callback confirmCallback
         * @param {string} message -user input message
         * 
         */
        /**
         * 設定對話框並開啟
         * @param {string} title 
         * @param {string} message 
         * @param {confirmCallback} confirmCallback 
         * @param {function} cancelCallback 
         * @param {string} placeholder 
         * @param {string} confirmTxt 
         * @param {string} cancelTxt 
         */
        showDialog(title, message, confirmCallback, cancelCallback, defaultMessage = "", placeholder = "", confirmTxt = "確定", cancelTxt = "取消", confirmColor = "orange", cancelColor = "blue") {
            this.title = title;
            this.message = message;
            this.promptMessage = defaultMessage;
            this.confirmTxt = confirmTxt;
            this.cancelTxt = cancelTxt;
            this.placeholder = placeholder;
            this.confirmCallback = confirmCallback;
            this.cancelCallback = cancelCallback;
            this.confirmBtnColor = confirmColor;
            this.cancelBtnColor = cancelColor;
            this.show = true;

            console.log(this.confirmBtnColor);
        },
        /**
         * 執行confirm callback
         */
        handleConfirm() {
            if (typeof this.confirmCallback == "function") {
                this.confirmCallback(this.promptMessage);
            }
        },
        /**
         * 
         */
        handleCancel() {
            if (typeof this.cancelCallback == "function") {
                this.cancelCallback(this.promptMessage);
            }
        },
        handleClose() {
            this.show = false;
        },
        setConfirmPrompt(txt) {
            this.confirmPrompt = txt;
        },
        setCancelPrompt(txt) {
            this.cancelPrompt = txt;
        }
    },
    computed: {
        // buttonBackgroundColor() {
        //     return (color) => {
        //         const colors = {
        //             "blue": "blue-btn",
        //             "orange": "orange-btn",
        //             "light-orange": "light-orange-btn"
        //         }
        //         let buttonClass = colors[color];
        //         return buttonClass;
        //     }
        // }
    },
    watch: {
        "show": {
            handler: function (newValue) {
                if (!newValue) {
                    this.setConfirmPrompt("");
                    this.setCancelPrompt("");
                }
            }
        }
    }
}
</script>

<style scoped>
.button-slot {
    margin-bottom: 1rem;
}

.dialog-input {
    height: 1.5rem;
    width: calc(100% - 8rem);
    font-size: 1.2rem;
    margin-left: 0.5rem;
}

.dialog-input::placeholder {
    font-size: 1rem;
}

.prompt {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
}

.dialog-message {
    margin-left: 2.5rem;
}

.prompt-txt {
    font-size: 12px;
}
</style>